import React, { useContext } from 'react';
import { style } from 'typestyle';
import { useTranslation } from 'react-i18next';
import * as styles from '../../check-in-employees.styles';
import Column from '../../../../core/components/column/column.component';
import { IsMobileContext } from '../../../../core/context/is-mobile';
import type Department from '../../../offices/models/department/department';
import DayPartDepartmentCard from '../../cards/day-part-cards/day-part-department-card.component';
import Grid from '../../../../core/components/grid/grid.component';

interface Props {
  readonly departments: Department[];
  readonly selectedDepartment: Department | undefined;
  readonly onDepartmentSelectionChanged: (department: Department) => void;
}

const DayPartDepartmentGroup = ({ departments, selectedDepartment, onDepartmentSelectionChanged }: Props): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();
  return (
    <div className={style(styles.sectionCard(isMobile))}>
      <Column>
        <span className={style(styles.columnHeader(isMobile))}>{t('departments').toLocaleUpperCase()}</span>
        {departments.length === 0 ? (
          <span className={style(styles.emptyListMessage)}>{t('no-departments-available')}</span>
        ) : (
          <Grid
            rowClass={style(styles.gridRow)}
            numberOfColumns={isMobile ? 1 : 3}
            itemSpacing={12}
            numberOfItems={departments.length}
            renderItem={(index): React.JSX.Element | undefined => {
              if (departments) {
                const department = departments[index];
                return (
                  department && (
                    <div className={isMobile ? style(styles.rowItem(true)) : undefined} key={department.id}>
                      <DayPartDepartmentCard
                        department={department}
                        isSelected={selectedDepartment?.id === department.id}
                        onClick={(value): void => {
                          onDepartmentSelectionChanged(value);
                        }}
                      />
                    </div>
                  )
                );
              }

              return undefined;
            }}
          />
        )}
      </Column>
    </div>
  );
};

export default DayPartDepartmentGroup;
